export default __webpack_public_path__ + "static/media/burial.9e497acf.svg";